import React, { createContext, useContext, useState } from "react";

const UserContext = createContext();

export const useUser = () => useContext(UserContext);

export const UserProvider = ({ children }) => {

    const [appUser, setAppUser] = useState(() => {
        const saved = localStorage.getItem("appUser");
        return saved ? JSON.parse(saved) : null;
    });

    const setUser = (userData) => {
        setAppUser(userData);
        localStorage.setItem("appUser", JSON.stringify(userData));
    };

    const clearUser = () => {
        setAppUser(null);
        localStorage.removeItem("appUser");
    };

    return (
        <UserContext.Provider value={{ appUser, setUser, clearUser }}>
            {children}
        </UserContext.Provider>
    );
};
